import * as updateUserById from "@/api/users/update";

export default {
	namespaced: true,
	state: {
		user: {},
		id: "",
		error: null,
	},
	getters: {
		readUser: (state) => state.user,
		readId: (state) => state.id,
		readError: (state) => state.error,
	},
	mutations: {
		SET_USER(state, payload) {
			state.user = payload;
		},
		SET_ID(state, payload) {
			state.id = payload;
		},
		SET_ERROR(state, payload) {
			state.error = payload;
		},
	},
	actions: {
		async updateUser({ commit, getters,rootGetters }) {
			const token = rootGetters['loginStore/readToken'];
			const updateUserRes = await updateUserById
				.updateUser(token,getters.readId, getters.readUser)
				.then(() => {
					return true;
				})
				.catch((error) => {
					if (error.response) {
						let message =
							error.response.data.message ||
							error.response.data.detail[0].msg;
						message == "Token expired"
							? commit("loginStore/SET_ACCESS_TOKEN", null, {
									root: true,
							  })
							: message
							? commit("SET_ERROR", message)
							: commit("SET_ERROR", "Algo salió mal");
					} else {
						console.log(error);
						commit("SET_ERROR", error);
					}
				});
			return updateUserRes;
		},
	},
};
